import type {
  SellerFaqItemConfig,
  SellerFaqPayment,
} from "@/constants/sellerFaqConfig";
import { ActivityPaymentModel, UserRole } from "@/types";

export type SellerFaqPaymentContext = {
  hasUpfrontActivities: boolean;
  hasReceiptActivities: boolean;
};

export function sellerFaqPaymentContext(
  activities: ReadonlyArray<{ payment_model: string }>,
): SellerFaqPaymentContext {
  let hasUpfrontActivities = false;
  let hasReceiptActivities = false;
  for (const activity of activities) {
    if (activity.payment_model === ActivityPaymentModel.UPFRONT) {
      hasUpfrontActivities = true;
    }
    if (activity.payment_model === ActivityPaymentModel.RECEIPT_BASED) {
      hasReceiptActivities = true;
    }
  }
  return { hasUpfrontActivities, hasReceiptActivities };
}

function matchesPaymentFilter(
  payment: SellerFaqPayment,
  role: UserRole | undefined,
  context: SellerFaqPaymentContext,
): boolean {
  if (payment === "all") {
    return true;
  }
  if (payment === "in_loco") {
    return context.hasReceiptActivities;
  }
  if (payment === "online") {
    return role === UserRole.HOST || context.hasUpfrontActivities;
  }
  return true;
}

function matchesRoleFilter(
  item: SellerFaqItemConfig,
  role: UserRole | undefined,
): boolean {
  if (role === UserRole.ADMIN) {
    return true;
  }
  if (role === UserRole.SELLER) {
    return item.roles.includes("partner");
  }
  if (role === UserRole.HOST) {
    return item.roles.includes("host");
  }
  if (role === UserRole.SALES_AGENT) {
    return item.id === "supportTicket";
  }
  return false;
}

export function isSellerFaqItemVisible(
  item: SellerFaqItemConfig,
  role: UserRole | undefined,
  context: SellerFaqPaymentContext,
  activitiesLoaded: boolean,
): boolean {
  if (!matchesRoleFilter(item, role)) {
    return false;
  }
  if (item.payment === "all") {
    return true;
  }
  if (!activitiesLoaded && role === UserRole.SELLER) {
    return true;
  }
  return matchesPaymentFilter(item.payment, role, context);
}
